var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        [
          _c("h2", [_vm._v("Collector Log Levels")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                icon: "",
                color: "grey lighten-1",
                loading: _vm.loadingCollectors || _vm.loading,
              },
              on: { click: _vm.refresh },
            },
            [_c("v-icon", [_vm._v("fas fa-sync")])],
            1
          ),
          _vm._v(" "),
          _c("v-select", {
            attrs: {
              items: _vm.allCollectors,
              "item-text": "id",
              "item-value": "id",
              label: "Source Collector",
            },
            model: {
              value: _vm.selectedCollectorId,
              callback: function ($$v) {
                _vm.selectedCollectorId = $$v
              },
              expression: "selectedCollectorId",
            },
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "append-icon": "fal fa-search",
              placeholder: "Search",
              "single-line": "",
              "hide-details": "",
              clearable: "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          items: _vm.filteredLogLevels(),
          search: _vm.search,
          loading: _vm.loading,
          headers: _vm.headers,
        },
        scopedSlots: _vm._u([
          {
            key: "item.loglevel",
            fn: function (item) {
              return [
                _c(
                  "td",
                  { staticClass: "actions" },
                  [
                    _c(
                      "v-radio-group",
                      {
                        staticClass: "regular--text",
                        attrs: { row: "", "hide-details": "" },
                        model: {
                          value: item.item.loglevel,
                          callback: function ($$v) {
                            _vm.$set(item.item, "loglevel", $$v)
                          },
                          expression: "item.item.loglevel",
                        },
                      },
                      [
                        _c("v-radio", {
                          key: 1,
                          class: { "red--text": item.value === "ERROR" },
                          attrs: { label: "Error", value: "ERROR" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          key: 2,
                          class: { "red--text": item.value === "WARN" },
                          attrs: { label: "Warn", value: "WARN" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          key: 3,
                          class: { "red--text": item.value === "INFO" },
                          attrs: { label: "Info", value: "INFO" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          key: 4,
                          attrs: { label: "Debug", value: "DEBUG" },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          key: 5,
                          class: { "red--text": item.value === "TRACE" },
                          attrs: { label: "Trace", value: "TRACE" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-card-actions", [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { loading: _vm.saving },
            on: { click: _vm.save },
          },
          [_vm._v("Apply Collector Log Levels")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }